import { decrypt, deepChangeUid } from "utils"
import { reverseBuildModel } from "utils/reverseBuildModel.js"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import instance from "../interceptor"
import api from "../api/index"
import { menuReadyCache } from '@/utils/leftMenuCache'
//初始化左侧菜单栏
// 获取组件分类集合
// 获取分类Id
const getModuleList = async typeId => {
  console.log("typeId", typeId)
  return await api.queryComponentTypeTree({ pid: typeId})
}

const getModuleContent = async tempList => {
  const id = tempList?.encId
  return api.queryComponentList({
    typeId: id,
    p2: 20
  })
}

//获取我的模板（保存的某一个画布样式）
const getStageModules = async () => {
  let moduleContent = await getModuleContent({ encId: "20106053E31351DC" })
  moduleContent = moduleContent?.data?.data?.PageInfo
  if (!moduleContent) return
  moduleContent.list.map(item => {
    if (item !== undefined && item.content && item.content.length > 30) {
      //还原被encryption方法加密过json字符串
      item.content = decrypt(item.content, data_dictionary_map)
      //将json中的rem转为px
      reverseBuildModel(item.content)
      return item
    } else return item
  })
  return moduleContent.list
}

// 获取组件分类以及 收藏的组件
async function initModules() {
  let typeId
  const ModuleTypeId = await getModuleList()
  let ModuleTypeIds = ModuleTypeId.data?.data?.list
  // 需要获取的分类样式
  const otherPcModuleNames = ["新通栏样式", "通栏样式", "通栏子组件", "列表页模板", "详情页模板", "搜索列表页", "导航列表页","后台分类列表组件"]
  const otherAppModuleNames = [
    "移动端通栏样式",
    "移动端通栏子组件",
    "移动端列表页模板",
    "移动端详情页模板",
    "移动端搜索列表页",
    "移动端导航列表页",
    "新移动端通栏样式",
    "后台分类列表组件"
  ]
  const otherPcModuleTypes = ModuleTypeIds.filter(item => otherPcModuleNames.indexOf(item.name) > -1)
  const otherAppModuleTypes = ModuleTypeIds.filter(item => otherAppModuleNames.indexOf(item.name) > -1)

  let typeName
  switch (this.request_prefix) {
    case "stage":
      typeName = "门户组件"
      // typeId = "21045CBF84681C8D"
      break
    case "appStage":
      typeName = "移动端组件"
      // typeId = "0456826339DA7D9F" // 10
      // typeId = "7C94E1270F68833A" // 线上
      break
    case "bigScreen":
      typeName = "大屏组件"
      // typeId = "47E686D35D4E683F"
      break
    default:
  }
  let moduleTypelist = []
  typeId = ModuleTypeIds.find(data => {
    if (data.name.indexOf(typeName) > -1) {
      moduleTypelist = data.subs
    }
    return data.name.indexOf(typeName) > -1
  }).encId
  if (!typeId) {
    return
  }
  if (this.request_prefix !== "bigScreen") {
    console.log("moduleTypelist", moduleTypelist)
    const needReadyModule = moduleTypelist.filter(item => ['图文列表', '文本列表'].includes(item.name))
    if (needReadyModule.length) {
      requestIdleCallback(() => {
        needReadyModule.map(module => {
          menuReadyCache.getReadyData(module.encId, module.name)
        })
      })
    }
    switch (this.request_prefix) {
      case "stage":
        // this.$store.dispatch("menu/setModules", data.complateModuleList)
        this.$store.dispatch("menu/setModuleTypes", moduleTypelist)
        console.log('moduleTypelist的值是', moduleTypelist)
        this.$store.dispatch("menu/setOtherModuleTypes", otherPcModuleTypes)

        ModuleTypeIds.forEach(data => {
          if (data.name.indexOf("移动端组件") > -1) {
            // 移动端一起写入，为了app同步pc端数据的对应关系typeid
            this.$store.dispatch("appMenu/setModuleTypes", data.subs)
          }
        })
        break
      case "appStage":
        // this.$store.dispatch("appMenu/setModules", data.complateModuleList)
        this.$store.dispatch("appMenu/setModuleTypes", moduleTypelist)
        this.$store.dispatch("appMenu/setOtherModuleTypes", otherAppModuleTypes)
        break
      default:
    }
  } else {
    // 目前只有大屏有收藏组件   默认返回前10条数据
    getBigScreenCollect.call(this, 1)
    //获取图文文本的数据
    this.$store.dispatch("bigScreenMenu/setModuleTypes", moduleTypelist)
  }
}
// 获取大屏的收藏
async function getBigScreenCollect(pageNum) {
  // desc=true 顺序为升序  不传则为降序
  let res = await instance.get(`v2/type/6D39D43861AF4301/list-enc?desc=true&p2=18&p=${pageNum}`)
  let collectComponent = res.data.data.PageInfo
  this.$store.dispatch("bigScreenMenu/setModules", collectComponent)
}
//  获取指定类型的列表, 每次修改之后去拿一级分类 和二级分类的数据
async function getModulesList(data) {
  const moduleData = await getModuleList()
  // 门户组件的时候这样处理
  const list = moduleData.data.data.list
  const modules = list.find(item => item.name === "门户组件")
  const moduleTypelist = modules.subs
  this.$store.dispatch("menu/setModuleTypes", moduleTypelist)

  // 移动端组件
  const appModules = list.find(item => item.name === "移动端组件")
  const appMouleTypelist = appModules.subs
  this.$store.dispatch("appMenu/setModuleTypes", appMouleTypelist)

  //大屏组件
  const bigScreenModules = list.find(item => item.name === "大屏组件")
  const bigScreenMouleTypelist = bigScreenModules.subs
  this.$store.dispatch("bigScreenMenu/setModuleTypes", bigScreenMouleTypelist)
}
async function initStageModules() {
  // 获取模板
  const stageModules = await getStageModules()
  this.$store.dispatch("menu/updateModule", {
    myModules: stageModules
  })
}

// 获取某个分类下的样式集合  比如所有的图文样式的encId  加了这个分类lsc=true  才能获取下级分下来的组件
async function getSystemModulesList(typeId) {
  let systemModulesList = await instance.get(`v2/type/${typeId}/list-enc?lsc=true&p2=20`)
  if (systemModulesList.data.code === 0) return []
  systemModulesList = systemModulesList?.data?.data?.PageInfo
  switch (this.request_prefix) {
    case "stage":
      this.$store.dispatch("menu/setSystemModules", {
        type: typeId,
        list: systemModulesList.list
      })
      break
    case "appStage":
      this.$store.dispatch("appMenu/setSystemModules", {
        type: typeId,
        list: systemModulesList.list
      })
      break
    case "bigScreen":
      this.$store.dispatch("bigScreenMenu/setSystemModules", {
        type: typeId,
        list: systemModulesList.list
      })
      break
    default:
  }

  return systemModulesList.list
}

/**
 * 获取子页面样式
 * @param {*} typeId
 * @param {*} engineInstanceId
 * @returns
 */
async function getSubPageModulesList(typeId, engineInstanceId, typeName) {
  let systemModulesList = []
  // 除了获取默认的系统数据外还要加上收藏列表数据
  if(this.$store.state[this.request_prefix].type === "listPage"){
    let collectList = [], collectId = ""
    //  查找"后台分类列表组件"下的数据
    let otherModuleTypes = [], listComponent = []
    if (this.request_prefix === "appStage") {
      otherModuleTypes = this.$store.state.appMenu.menu.otherTypes || []
    } else if (this.request_prefix === "stage") {
      otherModuleTypes = this.$store.state.menu.menu.otherTypes || []
    } else if (this.request_prefix === "bigScreen") {
      otherModuleTypes = this.$store.state.bigScreenMenu.menu.otherTypes || []
    }
    if(otherModuleTypes.length > 0){
      listComponent = otherModuleTypes.find(item => item.name === "后台分类列表组件").subs
    }
    let elementName = this.$store.state.states.getDataPageIds.name
    let typeName1 = ""
    if(typeName === "cxGaphic"){
      typeName1 = "图文列表"
    }else if(typeName === "cxSystemText"){
      typeName1 = "文本列表"
    }
    listComponent.forEach(item => {
      if (item && (elementName.includes(item.name) || typeName1.includes(item.name))) {
        collectId = item.encId
      }
    })
    if(collectId){
      let collectRes = await api.queryComponentList({
        typeId: collectId,
        p2: 100,
        lsc: true
      })
      if (collectRes.data.code === 0) return []
      // 默认样式不展示
      const defaultModuleId = ["development", "test"].includes(process.env.NODE_ENV)
          ? "3bed0f5268840111ee0a4617b1a704ae50e4"
          : "0ff11d4d1b5b2111ee1abc352b5e251c9164"
      collectList = collectRes?.data?.data?.PageInfo?.list.filter(item => item.encId !== defaultModuleId)
    }
    systemModulesList = systemModulesList.concat(collectList)
  }
  switch (this.request_prefix) {
    case "stage":
      this.$store.dispatch("menu/setSystemModules", {
        type: typeId,
        list: systemModulesList
      })
      break
    case "appStage":
      this.$store.dispatch("appMenu/setSystemModules", {
        type: typeId,
        list: systemModulesList
      })
      break
    case "bigScreen":
      this.$store.dispatch("bigScreenMenu/setSystemModules", {
        type: typeId,
        list: systemModulesList
      })
      break
    default:
  }

  return systemModulesList
}
// 获取二级分类下的第一个分类下的第一个数据
async function getFirstModuleEncId(encTypeId) {
  let data
  await api
    .queryDefaultComponent({
      t: encTypeId
    })
    .then(res => {
      data = res.data.data.moduleContent
      if (data !== undefined && data.content && data.content.length > 30) {
        //还原被encryption方法加密过json字符串
        data.content = decrypt(data.content, data_dictionary_map)
        // 保留样式的原始id,从而进行问题追溯
        data.content.options.publicId = res.data.publicId
        //将json中的rem转为px
        reverseBuildModel(data.content)
      }
    })
  data.content.options.isSystemComponent = true
  data.content.options.isIndependenceComponent = data.content.shape === "swiperComponent" ? false : true
  data.content.options.componentTypeId = encTypeId
  data.content.options.encId = data.encId
  data.content.options.isDefaultComponent = false
  //  删除栅格标记
  delete data.content.i
  return data
}
// 根据encId 获取当前组件的webJson
/**
 *
 * @param {string} encId 组件的id，根据该id拿到对应webjson
 * @param {boolean} isAppMode 是否去那当前组件的移动端样式
 * @returns
 */
async function getSyetemModuleJson(encId, isAppMode) {
  let res = await api.queryComponentContent({
    encId: encId,
    p2: 20,
    a: isAppMode ? 1 : 0
  })
  let data = res?.data?.data
  if (!data) {
    console.error("接口请求错误：encId_" + encId)
    return
  }
  let content = isAppMode ? data.appContent : data.content
  if (data !== undefined && content && content.length > 30) {
    //还原被encryption方法加密过json字符串
    content = decrypt(content, data_dictionary_map)
    //将json中的rem转为px
    reverseBuildModel(content)
  } else {
    console.error(`应用${encId}没有对应的${isAppMode ? "移动端" : "pc端"}样式`)
    return
  }
  const _attribute = content
  delete _attribute.i
  let layoutUidMap = {}
  if (window.location.href.includes("appHome") && _attribute.options.width > 414) {
    _attribute.options.width = 414
  }
  if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
    //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
    layoutUidMap = deepChangeUid(_attribute)
  }
  _attribute.options.publicId = res.data.data.publicId
  _attribute.options.layoutUidMap = layoutUidMap
  return _attribute
}
export {
  initModules,
  initStageModules,
  getModulesList,
  getSystemModulesList,
  getSubPageModulesList,
  getSyetemModuleJson,
  getFirstModuleEncId,
  getBigScreenCollect
}
